// Client-side config. Values are PUBLIC (not secrets).
// Populate via .env.local with VITE_-prefixed vars; see .env.local.example.
// The Lightning Out SDK script tag in index.html must match SF_INSTANCE_URL.
export const SF_INSTANCE_URL =
    import.meta.env.VITE_SF_INSTANCE_URL ||
    "https://se1765571596068--mac.sandbox.my.salesforce.com";

// Lightning Out App record Id. The app must expose c-search-results.
export const LO_APP_ID = import.meta.env.VITE_LO_APP_ID || "1UsD70000004C98KAE";

// Components registered with the Lightning Out application.
// A single root LWC (c-app-root) owns all view switching internally, so the
// host only mounts one element — one iframe, one bootstrap, no races.
export const LO_COMPONENTS = import.meta.env.VITE_LO_COMPONENTS || "c-app-root";
